const issuer = (import.meta.env.VITE_AUTH_URL ?? "https://auth.example.com").replace(/\/$/, "");

interface Discovery {
  issuer: string;
  authorization_endpoint: string;
  token_endpoint: string;
  revocation_endpoint?: string;
}

let pending: Promise<Discovery> | undefined;

export function discoverOidc(): Promise<Discovery> {
  pending ??= fetch(`${issuer}/.well-known/openid-configuration`)
    .then(async (response) => {
      if (!response.ok) throw new Error("Сервис входа временно недоступен");
      const config = (await response.json()) as Discovery;
      if (config.issuer !== issuer) throw new Error("Неверный адрес сервиса входа");
      for (const endpoint of [config.authorization_endpoint, config.token_endpoint, config.revocation_endpoint]) {
        if (endpoint && new URL(endpoint).origin !== new URL(issuer).origin) {
          throw new Error("Неверный адрес операции входа");
        }
      }
      return config;
    })
    .catch((error: unknown) => {
      pending = undefined;
      throw error;
    });
  return pending;
}

export async function requestToken(parameters: Record<string, string>): Promise<Response> {
  const config = await discoverOidc();
  return fetch(config.token_endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
    body: new URLSearchParams(parameters),
  });
}

export async function revokeToken(token: string, clientId: string): Promise<void> {
  const config = await discoverOidc();
  if (!config.revocation_endpoint) return;
  const response = await fetch(config.revocation_endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({ token, token_type_hint: "refresh_token", client_id: clientId }),
  });
  if (!response.ok) throw new Error("Не удалось отозвать сессию");
}
